import { HttpService } from '@/services/http.service';

export default {
    async login(credentials) {
        return await HttpService.httpPost(`/login`, credentials);
    }
}
